import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useClientSpecificHideRevokeAvatarConsentLink } from '@hooks/clientSpecificUtils';
import { useMytaverse } from '@providers/MytaverseProvider';
import AvaturnRevokeConsentModal from '../Modals/AvaturnRevokeConsentModal';
import { IRevokeConsent } from './interfaces';
import ParticipantsService from '@services/ParticipantsService';
import { IUser } from '@interfaces/user';
import { useStyles } from './styles';

const RevokeConsent = ({ t: translate, onRevokeConsent }: IRevokeConsent) => {
  const classes = useStyles();
  const [openRevokeConsentModal, setOpenRevokeConsentModal] =
    useState<boolean>(false);
  const {
    user,
    setCurrentAvatarId,
    setCustomAvatarUrl,
    setUser,
    setUserAvatars,
  } = useMytaverse();
  const hideRevokeConsentLink = useClientSpecificHideRevokeAvatarConsentLink();

  const handleRevokeConsent = async () => {
    const userUpdate = {
      isAvatarTermsAccepted: false,
      activeAvatarId: '',
    };
    const res = await ParticipantsService.updateCurrentParticipantAvatar(
      userUpdate,
    );

    setCurrentAvatarId('');
    setCustomAvatarUrl('');
    let userAvatars = user.avatars;
    // updating the list with the avatars returned
    if (res && res.avatars) {
      const idsFromRes = new Set(res.avatars.map((avatar) => avatar.avatarId));
      userAvatars = user.avatars.filter((avatar) =>
        idsFromRes.has(avatar.avatarId),
      );
    }
    setUser((prevState: IUser) => ({
      ...prevState,
      ...userUpdate,
      avaturnId: '',
      avatars: userAvatars,
    }));
    setUserAvatars(userAvatars);
    onRevokeConsent && onRevokeConsent();
    setOpenRevokeConsentModal(false);
  };

  if (!hideRevokeConsentLink && !!user.isAvatarTermsAccepted) {
    return (
      <>
        <Typography
          sx={classes.revokeConsentText}
          onClick={() => setOpenRevokeConsentModal(true)}
        >
          {translate('revokeCustomAvaturnConsent.textLink')}
        </Typography>
        <AvaturnRevokeConsentModal
          open={openRevokeConsentModal}
          onClose={() => setOpenRevokeConsentModal(false)}
          onConfirm={handleRevokeConsent}
        />
      </>
    );
  } else {
    return null;
  }
};

export default withTranslation()(RevokeConsent);
